module.exports = ":host ::ng-deep .toaster-button {\n  line-height: initial !important;\n  min-width: auto; }\n"